import React from "react";
import { useState, useEffect, useContext } from 'react'

import { ref, onValue } from "firebase/database";

import { db } from '../utils/firebaseApp.js';

import { AuthContext } from "../utils/auth.js";

import { PlusIcon } from '@heroicons/react/20/solid'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function CreditsComponent() {
    const { currentUser } = useContext(AuthContext);
    let userId = currentUser.uid;

    const [credits, setCredits] = useState(null);

    useEffect(() => {
        setCredits(null);
        const creditsRef = ref(db, 'userDetails/' + userId + '/credits/credits');

        const unsubscribe = onValue(creditsRef, (snapshot) => {
            const data = snapshot.val();
            if (data !== null) {
                let rawCredits = data || 0;
                let processedCredits = rawCredits / 10;

                setCredits(processedCredits);
            } else {
                setCredits(0);
            }
        }, () => {
            setCredits(0);
        });

        return () => unsubscribe();
    }, [userId]);

    return (
        <a href="/billing" className="group flex items-center cursor-pointer relative transition duration-300 ease-in-out">
            <span className="text-sm text-gray-900 group-hover:text-indigo-500 transition-colors duration-300 ease-in-out" aria-live="polite">
                {credits === null ? (
                    <Skeleton width={72} height={16} />
                ) : (
                    `${credits.toLocaleString()} pages`
                )}
            </span>
            <div className="absolute hidden group-hover:block bg-white text-gray-900 text-xs rounded py-1 px-2 top-full left-1/2 transform -translate-x-1/2 translate-y-1 border border-gray-300 whitespace-nowrap">
                Buy pages
            </div>
            <button
                className="ml-2 inline-flex items-center justify-center p-1 rounded-full bg-white border border-gray-300 text-gray-400 hover:text-primary hover:border-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition duration-300 ease-in-out"
                aria-label="Buy pages"
            >
                <PlusIcon className="w-4 h-4 group-hover:text-indigo-500 transition-all duration-300 ease-in-out" aria-hidden="true" />
            </button>
        </a>
    );
};
